export const ADMIN_HOME_URL = '/dashboard/analytics';
const AUTHENTICATION_URL_PREFIX = '/pages/authentication/';

export function resolveAdminReturnUrl(returnUrl: string): string {
  if (
    returnUrl &&
    returnUrl.charAt(0) === '/' &&
    returnUrl.indexOf('//') !== 0 &&
    returnUrl.indexOf(AUTHENTICATION_URL_PREFIX) !== 0
  ) {
    return returnUrl;
  }

  return ADMIN_HOME_URL;
}
